<template>
	<section>
		<h1 class="text-h3 py-3">
			A retenir
		</h1>
		<div
			class="d-flex flex-column flex-md-row"
			style="gap: 20px"
		>
			<div style="flex: 1">
				<SectionTitle>
					Avant le RDV avec le psychologue
				</SectionTitle>
				<SubSection>
					<strong>Désormais l’accès direct au psychologue est possible.</strong>
				</SubSection>
				<SubSection>
					<strong>Il est toujours possible de consulter au préalable un médecin, une sage-femme ou un membre
						du personnel médical scolaire si vous le désirez</strong> (notamment si le motif de consultation
					est lié à une ALD, une maternité ou un AT-MP).
				</SubSection>
				<SubSection>
					En cas d’imprévu, pensez à <strong>bien prévenir le psychologue de votre désistement.</strong> En
					l’informant rapidement de votre absence, vous permettez à un autre patient de bénéficier d’un suivi.
				</SubSection>
			</div>
			<div style="flex: 1">
				<SectionTitle>
					Le jour du RDV avec le psychologue
				</SectionTitle>
				<SubSection>
					Si vous n’avancez pas les frais en raison de soins en lien avec une maladie, une maternité ou un
					AT-MP, vous apportez <strong>votre attestation papier de droits à jour ou le courrier
						d’accompagnement éventuel de votre médecin ou de votre sage-femme.</strong>
				</SubSection>
				<SubSection>
					Certains psychologues peuvent réaliser des séances de suivi à distance, cependant la première
					séance d’entretien d’évaluation est <strong>obligatoirement réalisée en présentiel.</strong>
				</SubSection>
			</div>
			<div style="flex: 1">
				<SectionTitle>
					Après le RDV avec le psychologue
				</SectionTitle>
				<SubSection>
					Vous envoyez la <strong>feuille de soins remise par le psychologue</strong> à votre organisme
					d’assurance maladie (sauf si vous n’avez pas avancé les frais).
				</SubSection>
				<SubSection>
					12 séances sont remboursées au maximum par année civile. A la fin de l’accompagnement, le
					psychologue peut avec votre accord adresser au médecin <strong>un compte-rendu de fin de prise en
						charge.</strong>
				</SubSection>
			</div>
		</div>
	</section>
</template>

<script lang="ts">
	import Component from 'vue-class-component';
	import Vue from 'vue';

	import SubSection from '@/components/search-psychologist/remember-section/SubSection.vue';
	import SectionTitle from '@/components/search-psychologist/remember-section/SectionTitle.vue';

	/**
	 * Section "A retenir"
	 */
	@Component({
		components: {
			SubSection,
			SectionTitle
		}
	})
	export default class RememberSection extends Vue {

	}
</script>
